var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter p-2 flex-fill text-center"},[_c('h2',[_c('number',{attrs:{"to":_vm.to}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }